// src/components/sidebar/sidebarActive.js
export function normalizePath(p = "") {
    return String(p).replace(/^\/+/, "").replace(/\/+$/, "");
  }
  
  /**
   * currentPathname: location.pathname (ex: "/clube/pagamentos")
   * itemPath: seu path no menu (ex: "clube/pagamentos" ou "clube")
   */
  export function isPathActive(currentPathname, itemPath) {
    const cur = normalizePath(currentPathname);
    const tgt = normalizePath(itemPath);
  
    if (!tgt) return false;
    if (cur === tgt) return true;
  
    // Prefixo: "clube/pagamentos" ativa também "clube"
    return cur.startsWith(tgt + "/");
  }
  